import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context";
import { useTranslation } from "react-i18next";
import { SHOW_TOAST, STRINGS } from "../../constants";
import { getSearchList } from "../../api";
import { getFreeBookList } from "../../api/user";
import { useNavigate } from "react-router-dom";
import { AutoComplete, Input } from "antd";
import FreebookCard from "../../components/FreebookCard";

const FreeBook = () => {
  const { user, activeLanguage } = useContext(AuthContext);

  const { t } = useTranslation();

  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchBookList, setSearchBookList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [autoData, setAutoData] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    onExploreList();
  }, []);

  async function onExploreList() {
    const params = {
      searchText: search,
      userId: user?.userInfo?._id,
    };

    setIsLoading(true);
    const result = await getSearchList(params);
    // const result2 = await getExploreBookList(user?.userInfo?._id);
    const result2 = await getFreeBookList();
    const Data = result2?.data?.data?.map((ele) => {
      return {
        label: ele?.bookName,
        value: ele?.bookName,
      };
    });

    setAutoData(Data);
    setIsLoading(false);

    if (result?.status) {
      const res2 = result2?.data?.data ?? [];
      setSearchBookList(res2);
      setFilteredData(res2);
    } else {
      SHOW_TOAST(t(STRINGS?.something_went_wrong), "error");
      setFilteredData([]);
    }
  }

  useEffect(() => {
    const filtered = filteredData.filter((item) => {
      return (
        item?.bookName?.toLowerCase().includes(search.toLowerCase()) ||
        item?.keywords?.toLowerCase().includes(search.toLowerCase())
      );
    });
    if (search === "") {
      return setSearchBookList(filteredData);
    }

    setSearchBookList(filtered);
  }, [search]);

  const onSelect = (value) => {
    setSearch(value);
  };
  const handleSearch = (value) => {
    setSearch(value);
  };
  return (
    <div>
      <div
        className="flex items-center justify-center w-full 
      stickytop-20z-20bg-white
      "
      >
        <h2 className="w-full mx-auto text-lg font-bold">
          {t(STRINGS.freebooks)}
        </h2>
        <div className="w-full">
          <AutoComplete
            className="w-full"
            onFocus={(e) => {}}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={autoData}
            onSelect={onSelect}
            onSearch={handleSearch}
          >
            <Input
              size="lg"
              placeholder={t(STRINGS.search)}
              className="w-full"
            ></Input>
          </AutoComplete>
        </div>
      </div>

      <div className="mt-4">
        {isLoading ? (
          <div className="text-center h-96 w-full flex items-center justify-center">
            <p>Loading...</p>
          </div>
        ) : searchBookList && searchBookList.length > 0 ? (
          <div className="grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 grid-cols-2 gap-4">
            {searchBookList.map((item, idx) => (
              <div key={item?.bookName}>
                <FreebookCard
                  logo={item?.bookImage}
                  title={item?.bookName}
                  link={item?.bookLink}
                  subtitle={item?.bookSubTitle}
                  type="freebook"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center h-96 w-full flex items-center justify-center">
            <p>{t(STRINGS.no_data)}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FreeBook;
